<mat-checkbox [checked]="field.checked" [formControl]="fc" [disabledInteractive]="field.disabled" color="primary">{{
    field.name
}}</mat-checkbox>
